import { ActionTree } from "vuex";
import { baseApi } from "@/config/http-common";
import { IRootState } from "@/store";
import { IRoleState } from "@/store/modules/role/state";
import { RoleMutations } from "@/store/modules/role/mutations";
import { JobMutations } from "@/store/modules/job/mutations";

export enum RoleActions {
  FETCH_DATA_PROVIDER = "FETCH_DATA_PROVIDER_ROLE",
  FETCH_ONE = "FETCH_ONE_ROLE",
  FETCH_ALL = "FETCH_ALL_ROLE",
  CREATE = "CREATE_ROLE",
  UPDATE = "UPDATE_ROLE",
  DELETE = "DELETE_ROLE",
  DELETE_ALL = "SET_ALL_ROLE",
}

export const actions: ActionTree<IRoleState, IRootState> = {
  async [RoleActions.FETCH_DATA_PROVIDER]({ commit }, params) {
    try {
      const result = await baseApi.get("/common/roles/list", {
        params: params,
      });
      console.log(result);
      commit(RoleMutations.SET_LAZY_DATA, result.data.data);
    } catch (error) {
      console.log("get role data provider error: ", error);
    }
  },
  async [RoleActions.FETCH_ONE]({ commit }, id) {
    try {
      const result = await baseApi.get(`/common/roles/view/${id}`);
      commit(RoleMutations.SET_ONE, result.data.data);
    } catch (error) {
      console.log("fetch role one error: ", error);
    }
  },
  async [RoleActions.FETCH_ALL]({ commit }) {
    try {
      const result = await baseApi.get("/users/users/sub-data/roles");
      commit(RoleMutations.SET_ALL, result.data.data);
    } catch (error) {
      console.log("fetch role all error: ", error);
    }
  },
  async [RoleActions.CREATE]({ commit }, data: Document) {
    return new Promise((resolve, reject) => {
      baseApi
        .post("/common/roles/create", data)
        .then((data) => {
          commit(RoleMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("role create error: ", error);
          reject(error.response);
        });
    });
  },
  async [RoleActions.UPDATE]({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      baseApi
        .put(`/common/roles/update/${id}`, data)
        .then((data) => {
          commit(RoleMutations.SET_ONE, data);
          resolve(true);
        })
        .catch((error) => {
          console.log("role update error: ", error);
          reject(error.response);
        });
    });
  },
  async [RoleActions.DELETE]({ commit }, id: string) {
    try {
      await baseApi.delete(`/common/roles/delete/${id}`);
    } catch (error) {
      console.log("role delete error:", error);
    }
  },
  async [RoleActions.DELETE_ALL]({ commit }) {
    try {
      await baseApi.delete(`/roles`);
      commit(RoleMutations.SET_ALL, []);
    } catch (error) {
      console.log("role delete all", error);
    }
  },
};
